import React from 'react';
import Marquee from './Marquee';
import { Label, Panel } from './styles';
import { percentFormat } from '../../Utils/NumberFormatting';
import { css } from 'emotion';

export const link = css`
	color: #000;
	padding: 0 0.25rem;
`;

const getAllItems = (senateItems, regionalItems) => {
	const divider = {
		name: ' | '
	};
	const regionalElectionsName = {
		name: <strong> Krajské volby: </strong>
	}
	const senateElectionsName = {
		name: <strong> Senátní volby: </strong>
	}
	return [
		senateElectionsName,
		...senateItems,
		divider,
		regionalElectionsName,
		...regionalItems
	]
};

export default (props) => {
	const getSenateItems = () => props.districts.map(district => {
		const candidates = Object.values(props.candidates).filter(candidate => district.candidates.includes(candidate.id));
		const sortedCandidates = candidates.sort((a, b) => b.percent - a.percent).slice(0, 2);
		const bestCandidates = sortedCandidates.map(candidate => candidate.name + ' ' + candidate.lastName + ' - ' + percentFormat(candidate.percent[props.roundIndex], 0)).join(', ');
		const name = district.name + ' - ' + 'sečteno: ' + percentFormat(district.meta[props.roundIndex].count, 0) + ', ' + bestCandidates;
		return {
			name,
			link: props.linkToSenate + `#/obvod/${district.id}`
		}
	})


	const getRegionalItems = () => props.regions.map(region => {
		const sortedParties = region.parties.slice().sort((a, b) => b.percent - a.percent);
		const bestParty = sortedParties.sort((a, b) => b.percent - a.percent).slice(0, 1);
		const bestRegion = bestParty.map(region => region.name + ' - ' + percentFormat(region.percent));
		const name = region.name + ' - ' + 'sečteno: ' + percentFormat(region.meta.count, 0) + ', ' + bestRegion;
		return {
			name,
			link: props.linkToRegional + `#/kraj/${region.id}`
		}
	})


	const allItems = getAllItems(getSenateItems(), getRegionalItems());

	return (
		<Panel>
			<Label>Průběh sčítání:</Label>
			<Marquee>
				{allItems.map((item, index) => {
					return (
						<>
							{item.link ?
								<>
									<a className={link} key={index} href={item.link}>
										{item.name}
									</a>
									<span>.</span>
								</>
								:
								<span key={index}>
									{item.name}
								</span>
							}
						</>
					);
				})}
			</Marquee>
		</Panel>
	)
}
